import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { ActivationFilter } from './ActivationFilter';

export default withStyles(styles)(ActivationFilter);
